import Constructor from "../pages/Constructor";

export default {
    designerPage: {
        title: 'Дизайнерам',
        designerInfo: {
        heading: 'Для дизайнеров',
        paragraphs: [
            'Использование в отделке абсолютно любых материалов, таких как каменные слэбы, стекло, карбон, натуральный шпон, золото, натуральная кожа крокодила и других экзотических видов... Предела фантазии просто нет!',
            'Сотрудничество с нами сможет расширить Ваши возможности и удовлетворить требования самого изысканного клиента. А партнерство и взаимовыгодные отношения с нами - вдохновят Вас еще больше!',
        ],
        },
        diagrams: {
            floatingCabinet: 'Схемы парящей тумбы и панели',
            frame: 'Схемы каркаса',
            liftingMechanism: 'Схемы подъемного механизма',
        },
    },
    menuText: {
        buttons: {
            subscribeBtn: 'Подписаться',
            msgUs: 'Напишите нам'
        },
        links: {
            collection: 'КОЛЛЕКЦИЯ',
            gallery: 'ГАЛЕРЕЯ',
            constructor: 'КОНСТРУКТОР',
            designer: 'ДИЗАЙНЕРАМ',
            info: 'ИНФО'
        }
    },
    footer: {
        phone: 'Телефон: ',
        mail: 'Почта: '
    },
    infoPage: {
        title: 'Информация',
        p1: {
            title1: 'О нас',
            text1: 'Компания NIRIVS - это команда талантливых дизайнеров и проектировщиков, специализирующихся на создании эксклюзивных и роскошных парящих кроватей. Мы предлагаем уникальные решения для тех, кто ценит комфорт, стиль и передовые технологии. Компания NIRIVS стремится к постоянному развитию и совершенствованию своих технологий. Мы следим за новинками на рынке и внедряем самые передовые решения, чтобы наши клиенты могли наслаждаться самым современным и удобным парящим кроватью.',
            text2: 'Мы гордимся тем, что наша продукция отличается высокой стоимостью, ведь это подчеркивает эксклюзивность и качество наших изделий, мы ценим наш труд! Наши парящие кровати отличаются не только изысканным дизайном, но и непревзойденной качеством. Использование передовых материалов и технологий обеспечивает долговечность и надежность конструкции, а также непревзойденный комфорт во время сна. Каждый проект разрабатывается индивидуально для наших клиентов, учитывая их предпочтения и особенности интерьера. Мы предлагаем широкий выбор материалов, цветов и отделок, чтобы создать кровать, которая идеально впишется в ваш дом.',
            title2: 'Наша миссия',
            text3: 'Предоставить каждому клиенту кровать, которая станет не только удобным спальным местом, но и настоящим произведением искусства в вашем доме.'
        },
        phone: 'Телефон: ',
        address: 'Адрес: г. Ростов-на-Дону, пр. Михаила Нагибина, 30Л, 2 этаж'
    },
    mainPage: {
        title: 'Главная',
        img1: {
            desc1: 'Не имеет аналогов во всем мире',
            desc2: 'Самый реалистичный эффект парения',
            desc3: 'Пожизненная гарантия на конструкцию'
        },
        buttonsText1: 'Галлерея',
        buttonsText2: 'Конструктор',
        img2: {
            title: 'Эксклюзивность и роскошь',
            desc: 'NIRIVS специализируется на создании уникальных парящих кроватей, которые отличаются роскошным дизайном, созданным профессионалами, что в свою очередь обеспечивает клиентам не только высокий уровень комфорта и стиля в их интерьерах, но и подчеркивает эксклюзивность их пространства.'
        },
        img3: {
            title: 'Индивидуальный подход',
            desc: 'NIRIVS разрабатывает каждую кровать индивидуально, учитывая предпочтения и особенности интерьера клиента. Широкий выбор материалов, цветов и отделок позволяет создать идеальное сочетание, которое гармонично впишется в дом заказчика.'
        },
        img4: {
            title: 'Передовые технологии',
            desc: 'NIRIVS специализируется на создании уникальных парящих кроватей, которые отличаются роскошным дизайном, созданным профессионалами, что в свою очередь обеспечивает клиентам не только высокий уровень комфорта и стиля в их интерьерах, но и подчеркивает эксклюзивность их пространства.'
        },
        img5: {
            title: 'Крепкий каркас',
            p1: 'Каркас парящей кровати NIRIVS является собственной разработкой нашей компании и защищен патентом об изобретении. Тестирование кровати проходило несколько лет, это позволило максимально учесть все технические нюансы и пожелания пользователей.',
            p2: 'Конструктивной особенностью каркаса являются четыре ребра жесткости, расположенные по диагонали друг от друга вокруг центральной опоры, а несущая рама, изготовленная из специально разработанного алюминиевого профиля, объединяет всю конструкцию в одно целое и крепится шестью анкерными болтами в пол. Такое решение дает неограниченные возможности для дизайнерских идей и кстати, такую кровать можно поставить даже на яхте!',
            p3: 'Детали каркаса кровати NIRIVS изготовлены из авиационного сплава алюминия, покрытого специальным покрытием, защищающим их от окисления, в то же время придавая им современный и привлекательный вид. Сложная конфигурация деталей каркаса, материал из которого они изготовлены и сам конструктив придают наивысшую жесткость конструкции гарантировано исключая появление скрипов во время эксплуатации, что несомненно повышает ее комфорт. На данную конструкцию мы предоставляем пожизненную гарантию! Вес конструкции с основанием для матраса, составляет около 130 кг.'
        }
    },
    collectionPage: {
        title: 'Модели кроватей',
        additionalText: 'Включает:',
        model1: {
            title: 'ЛОФТ',
            features: [
                'Каркас кровати',
                'Деревянное изголовье',
                'Подсветку изголовья',
                '2 тумбы',
                'Место для хранения под матрасом',
            ],
        },
        model2: {
            title: 'ЛОТОС',
            features: [
                'Каркас кровати',
                'Деревянное / тканевое / кожаное изголовье',
                'Подсветку изголовья',
                '2 выдвижные тумбы',
                'Место для хранения под матрасом',
                'Выдвижные ящики для белья',
            ],
        },
        model3: {
            title: 'КЛАССИК',
            features: [
                'Каркас кровати',
                'Деревянное изголовье',
                'Подсветку изголовья',
                '2 тумбы',
                'Место для хранения под матрасом',
            ],
        },
        model4: {
            title: 'МИНИМАЛИЗМ',
            features: [
                'Каркас кровати',
                'Деревянное / тканевое / кожаное изголовье',
                'Подсветку изголовья',
                '2 выдвижные тумбы',
                'Место для хранения под матрасом',
                'Выдвижные ящики для белья',
            ],
        },
        model5: {
            title: 'ЛОФТ',
            features: [
                'Каркас кровати',
                'Деревянное изголовье',
                'Подсветку изголовья',
                '2 тумбы',
                'Место для хранения под матрасом',
            ],
        },
    },
    lotusPage: {
        title: 'Модель «ЛОТОС»',
        desc: 'Данный вариант отделки включает в себя царги, покрытые золотистым металликом и глянцевым лаком. В сочетании с теплыми тонами дизайнерского шпона, создают неповторимый облик, который подчеркивает в себе элегантность в сочетании с современным стилем и утонченностью.',
        variation: 'Вариант отделки «Sweet Dream»'
    },
    contacUs: {
        title: 'Напишите нам',
        mail: 'Почта:',
        phone: 'Телефон:',
        msg: 'Сообщение:',
        btnText: 'Отправить'
    },
    subcribe: {
        title: 'Подпишитесь на рассылку и будьте в курсе новостей компании NIRIVS',
        mail: 'Почта:',
        btnText: 'Подписаться на рассылку'
    }
  };
  